import UpdatePostModal from "./UpdatePostModal";

export default function UpdatePost({ isOpen, onClose, post }) {
  return <UpdatePostModal isOpen={isOpen} onClose={onClose} post={post} />;
}
